import { render } from "./MobilePhone.vue?vue&type=template&id=6821af6e&scoped=true"
import script from "./MobilePhone.vue?vue&type=script&lang=js"
export * from "./MobilePhone.vue?vue&type=script&lang=js"

import "./MobilePhone.vue?vue&type=style&index=0&id=6821af6e&lang=scss&scoped=true"
import "./MobilePhone.vue?vue&type=style&index=1&id=6821af6e&lang=css"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6821af6e"]])

export default __exports__